// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"c919e817","455":"33d775f8","977":"83aac2ce"}[chunkId] + ".chunk.js";
};